const INITIAL_PROGRESS = 6;
const MAX_ACTIVE_PROGRESS = 99;
const COMPLETE_PROGRESS = 100;
const PROGRESS_INTERVAL_MS = 180;
const COMPLETION_HOLD_MS = 280;
const LONG_REQUEST_THRESHOLD_MS = 15000;
const LONG_REQUEST_MESSAGE = 'Still loading…';

function getNextProgress(currentProgress) {
    const current = Number.isFinite(currentProgress) ? currentProgress : INITIAL_PROGRESS;
    let increment = 1;

    if (current < 38) increment = 8;
    else if (current < 68) increment = 5;
    else if (current < 82) increment = 2;

    return Math.min(MAX_ACTIVE_PROGRESS, current + increment);
}

function getLoadingDisplay(progress, isLongRunning) {
    return isLongRunning ? LONG_REQUEST_MESSAGE : `${progress}%`;
}

module.exports = {
    INITIAL_PROGRESS,
    MAX_ACTIVE_PROGRESS,
    COMPLETE_PROGRESS,
    PROGRESS_INTERVAL_MS,
    COMPLETION_HOLD_MS,
    LONG_REQUEST_THRESHOLD_MS,
    LONG_REQUEST_MESSAGE,
    getNextProgress,
    getLoadingDisplay,
};
